import {APP_ID, APP_INITIALIZER, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {CommonDomainModule} from 'common-domain';
import {environment} from '../environments/environment';
import {HomeModule} from './home/home.module';
import {DomainRoutingModule} from './domain/domain-routing.module';
import {ServiceWorkerModule} from '@angular/service-worker';
import {AppConfigService} from 'common-domain';
import {NgxSmartModalModule} from 'ngx-smart-modal';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule, POSITION, SPINNER} from 'ngx-ui-loader';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {BrowserModule, Title} from "@angular/platform-browser";
import {InfiniteScrollDirective} from "ngx-infinite-scroll";
import {provideHttpClient} from "@angular/common/http";

const ngxUiLoaderConfig: any = {
  delay: 100,
  maxTime: 2500,
  bgsType: SPINNER.threeStrings,
  bgsPosition: POSITION.centerCenter
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    HomeModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot(ngxUiLoaderConfig),
    CommonDomainModule.configure(environment),
    DomainRoutingModule,
    AppRoutingModule,
    InfiniteScrollDirective,
    NgxSmartModalModule.forRoot(),
    FontAwesomeModule
  ],
  providers: [
    Title,
    provideHttpClient(),
    {
      provide: APP_ID,
      useValue: 'serverApp'
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfigService: AppConfigService) => () => appConfigService.load("/home"),
      deps: [AppConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private library: FaIconLibrary) {
    library.addIconPacks(fas);
  }

}
